import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import StylePropType from 'react-style-proptype';

const validVariants = ['primary', 'secondary'];

function Button(props) {
  const {
    text,
    variant,
    onClick,
    iconName,
    iconPosition,
    disabled,
    large,
    style,
    ...restProps
  } = props;

  if (!validVariants.includes(variant)) {
    throw new Error(`type must be one of: ${validVariants}`);
  }

  return (
    <button
      type="button"
      className={classNames(
        'textbutton',
        `textbutton-skin-${variant}`,
        { 'textbutton-super': large },
        { 'textbutton-with-icon': iconName !== null },
        { 'textbutton-with-icon-left': iconPosition === 'left' },
      )}
      onClick={onClick}
      disabled={disabled}
      style={{
        margin: 4,
        ...style,
      }}
      {...restProps}
    >
      {text}
      {iconName && <span className={`textbutton-icon textbutton-icon-${iconName}`} />}
    </button>
  );
}

Button.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  iconName: PropTypes.string,
  iconPosition: PropTypes.oneOf(['right', 'left']),
  variant: PropTypes.oneOf(validVariants),
  disabled: PropTypes.bool,
  large: PropTypes.bool,
  style: StylePropType,
};

Button.defaultProps = {
  variant: 'primary',
  iconName: null,
  iconPosition: 'right',
  disabled: false,
  large: false,
  style: {},
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/Button.js